// Libs
// Components, Layouts, Pages
// Others
import { GRAY_500 } from '~/utils/constants/color';
// Styles, images, icons

type Props = {
  fill?: string;
  width?: number | string;
  height?: number | string;
};

const CommonIconEventTimeline = (props: Props) => {
  //#region Destructuring Props
  const { fill = GRAY_500, width = 28, height = 28 } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <svg width={width} height={height} viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='1' width='26' height='26' rx='13' fill='white' />
      <rect x='1' y='1' width='26' height='26' rx='13' stroke={fill} stroke-width='2' />
      <circle cx='14' cy='14' r='5' fill={fill} />
    </svg>
  );
};

export default CommonIconEventTimeline;
